export default {
  account: '账号',
  accountPlaceholder: '请输入账号',
  operationTime: '操作时间',
  startTime: '开始时间',
  endTime: '结束时间',
  search: '搜索',
  name: '姓名',
  ip: 'IP',
  applicationModule: '应用模块',
  operationContent: '操作内容',
  antiFake: '防伪溯源',
  marketing: '营销活动',
};
